import React, { useEffect } from 'react';
import HouseBanner from '../Components/HouseBanner/HouseBanner';
import Images from '../Assets/Images/Images';
import HouseInfo from '../Components/HouseInfo/HouseInfo';
import HouseFacilities from '../Components/HouseFacilities/HouseFacilities';
import HouseLocation from '../Components/HouseLocation/HouseLocation';

const HouseOfArieOne = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  });

  return (
    <>
      <HouseBanner
        houseNumber={1}
        imageUrl={Images.houseBannerOne}
      />
      <HouseInfo
        image={Images.houseOneInfo}
        carouselImages={Images.houseOneCarousel}
        text={[
          <p>House of Arie 1 adalah Kost khusus putri pertama yang di didirikan oleh House of Arie, berada di Jl. Depsos
            gang H. Mardan No. 72, Pesanggrahan, Jakarta Selatan. Terdapat 70 kamar fully-furnished yang siap untuk anda
            tempati.</p>,
          <p>Setiap kamar di desain mulai dari 3 meter persegi, dilengkapi dengan berbagai macam fasilitas untuk
            melengkapi kebutuhan penghuni. Kamar mandi dalam dengan water heater dan shower yang siap meluruhkan rasa
            penat, meja dan kursi, tempat tidur nyaman dan lemari pakaian.</p>,
          <p>Ada ruangan bersama dengan meja dan tempat duduk yang nyaman untuk bersantai sambil menikmati keindahan
            lingkungan yang asri dan suara lembut gemericik air mancur di taman, yang menenangkan pikiran. Dilengkapi
            pula dengan dapur bersama dengan dispenser, wastafel, dan kompor, dapur fungsional untuk memasak yang
            menyenangkan.</p>,
          <p>Security dan Kamera CCTV 24 Jam menambah rasa aman dan nyaman untuk penghuni House of Arie 1.</p>
        ]}
      />
      <HouseFacilities
        imageOne={Images.houseOneFac1}
        imageTwo={Images.houseOneFac2}
      />
      <HouseLocation
        mapUrl='https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15864.003009199201!2d106.7644129!3d-6.2636295!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x9b9696c7a2fa90a5!2sHouse%20of%20Arie!5e0!3m2!1sen!2sid!4v1597990641382!5m2!1sen!2sid'
        reviewUrl='https://g.page/kost-arie/review?gms'
      />
    </>
  );
};

export default HouseOfArieOne;
